module.exports = __webpack_public_path__ + "static/media/taiwan_1.f97e81c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/taiwan/taiwan_1.jpg
// module id = 562
// module chunks = 0